// extracted by mini-css-extract-plugin
export default {"container":"s3LKPq","tooltip":"MXGxaz"};